import React from 'react';
import { isServerUp } from './serverMonitoringUtils';

export function ServerMonitoringStatusCell({ record, onOpenLogs }) {
  if (!record) {
    return <span className="server-monitoring-cell server-monitoring-cell--na">N/A</span>;
  }

  const isUp = isServerUp(record);

  return (
    <div className="server-monitoring-cell">
      <span
        className={`server-monitoring-status-dot ${
          isUp ? 'server-monitoring-status-dot--up' : 'server-monitoring-status-dot--down'
        }`}
        title={isUp ? 'Running' : 'Down'}
        aria-label={isUp ? 'Server is up' : 'Server is down'}
      />
      <button
        type="button"
        className="server-monitoring-logs-link"
        onClick={() => onOpenLogs(record)}
      >
        logs
      </button>
    </div>
  );
}
